export function toArray(value) {
  if (value === undefined || value === null) {
    return [];
  }

  return Array.isArray(value) ? value : [value];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-field-form@1.1.3@rc-field-form/es/utils/typeUtil.js
// module id = 232
// module chunks = 0